import { useAuthAppStore } from "@/store/stores/authStore";

export class POApprovalMatrixService {
  async getAllEntities({ client, queryStr }) {
    var response = await client.get({
      route: "/approval-matrix/get-all-entities-paged",
      params: queryStr,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
        "Content-Type": "application/json",
      },
      successCallback: () => {},
      errorCallback: () => {},
    });

    return response;
  }

  async putEntities({ client, data, successCallback, errorCallback }) {
    await client.put({
      route: "/approval-matrix/update-entity",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      data: data,
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
  }

  async createEntities({ client, data, successCallback, errorCallback }) {
    await client.post({
      route: "/approval-matrix/create-entity",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      data: data,
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
  }

  async deleteEntity({ client, params, successCallback, errorCallback }) {
    await client.delete({
        route: "/approval-matrix/delete-entity",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Authorization": `Bearer ${useAuthAppStore().token}`
        },
        params: params,
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
  }

  async getAllEntitiesPaged({ poApprovalMatrixServiceClient, params }) {
    
    params.filter = JSON.stringify([
      "PurchaseOrderNumber", "=", params.poNumber,
    ]);

    var response = await poApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/get-all-entities-paged",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),

      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async getEntityByPkey({ poApprovalMatrixServiceClient, params }) {
    
    var response = await poApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/get-entity-by-pkey",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async getFindByPurchaseOrderNumber({ poApprovalMatrixServiceClient, params }) {
    var response = await poApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/find-by-purchase-order-number",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getFindByPurchaseOrderNumberWithComplex({ poApprovalMatrixServiceClient, params, complex }) {
    var response = await poApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/find-by-purchase-order-number",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": complex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getFindStagesByPurchaseOrderNumbers({
    poApprovalMatrixServiceClient,
    params,
    complexCode
  }) {
    var response = await poApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/find-by-purchase-order-numbers",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": complexCode,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });

    return response;
  }

  async replaceApprover({ poApprovalMatrixServiceClient, data }) {
    var response = await poApprovalMatrixServiceClient.put({
      route: "/approval-matrix-step/replace-approver",
      data: data,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function () {},
      errorCallback: function (resp) {
        console.log("resp", resp);
      },
    });
    return response;
  }

  async getApproveUrlByOrderNumbers({ poApprovalMatrixServiceClient, params, dataComlexCode }) {
    
    var response = await poApprovalMatrixServiceClient.get({
      route: "/approval-matrix-step/get-approval-url-by-order-numbers",
      params: params,
      //data: { Numbers: ["126"] },
      //data: JSON.stringify({"Numbers": "['126']"}),
      // JSON.stringify(["Number", "contains", searchQuery]);
      headers: {
        "X-YPH-COMPLEX": dataComlexCode,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

}
